import { MascotBubble } from '@tankef/ui';

import type { StepType } from '@reactour/tour';

export const INVESTMENTS_TOUR_ID = 'investments';

export const investmentsSteps: StepType[] = [
  {
    selector: '[data-tour="investments-kpi"]',
    position: 'bottom',
    content: (
      <MascotBubble emotion="happy" size="sm" direction="right" showPointer={false}>
        Tu <strong>resumen de inversiones</strong>: capital invertido, rendimientos acumulados y
        próximos pagos.
      </MascotBubble>
    ),
  },
  {
    selector: '[data-tour="investments-new-btn"]',
    position: 'bottom',
    content: (
      <MascotBubble emotion="thinking" size="sm" direction="left" showPointer={false}>
        Aquí exploras los <strong>proyectos disponibles</strong> para invertir. Cada uno muestra
        tasa, plazo y nivel de riesgo.
      </MascotBubble>
    ),
  },
  {
    selector: '[data-tour="investments-table"]',
    position: 'top',
    content: (
      <MascotBubble emotion="neutral" size="sm" direction="right" showPointer={false}>
        Tus <strong>inversiones activas</strong>. Toca una para ver la tabla de amortización,
        retención ISR y descargar el estado de cuenta.
      </MascotBubble>
    ),
  },
];
